var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-orders-show"
  }, [_vm.fetching ? _c('p', [_c('Loading')], 1) : [_c('Hero', {
    attrs: {
      "title": "消費明細"
    }
  }), _c('div', {
    staticClass: "s-space-y-2"
  }, [_c('DetailSection', {
    attrs: {
      "icon": "info",
      "title": "消費資訊"
    }
  }, [_c('table', {
    staticClass: "s-text-sm s-w-full"
  }, [_c('tr', [_c('td', {
    staticClass: "s-font-semibold"
  }, [_vm._v("門市")]), _c('td', {
    staticClass: "s-text-right"
  }, [_vm._v(_vm._s(_vm.transaction.branch.name))])]), _c('tr', [_c('td', {
    staticClass: "s-font-semibold"
  }, [_vm._v("時間")]), _c('td', {
    staticClass: "s-text-right"
  }, [_vm._v(_vm._s(_vm.time))])]), _c('tr', [_c('td', {
    staticClass: "s-font-semibold"
  }, [_vm._v("消費金額")]), _c('td', {
    staticClass: "s-text-right s-font-semibold"
  }, [_vm._v("NT$ " + _vm._s(_vm.transaction.total))])]), _c('tr', [_c('td', {
    staticClass: "s-font-semibold"
  }, [_vm._v("新增紅利點數")]), _c('td', {
    staticClass: "s-text-right"
  }, [_vm._v(_vm._s(_vm.transaction.point))])]), _c('tr', [_c('td', {
    staticClass: "s-font-semibold"
  }, [_vm._v("發票號碼")]), _c('td', {
    staticClass: "s-text-right"
  }, [_vm._v(_vm._s(_vm.transaction.invoice.invoice_number))])]), _c('tr', [_c('td', {
    staticClass: "s-font-semibold"
  }, [_vm._v("發票類型")]), _c('td', {
    staticClass: "s-text-right"
  }, [_vm._v(_vm._s(_vm.transaction.invoice.invoice_type))])])])]), _c('DetailSection', {
    attrs: {
      "icon": "list",
      "title": "消費明細"
    }
  }, [_c('table', {
    staticClass: "s-text-sm s-w-full"
  }, [_c('thead', [_c('tr', {
    staticClass: "s-font-semibold"
  }, [_c('th', [_vm._v("名稱")]), _c('th', {
    staticClass: "s-text-right"
  }, [_vm._v("數量")]), _c('th', {
    staticClass: "s-text-right"
  }, [_vm._v("金額")])])]), _c('tbody', _vm._l(_vm.transaction.items, function (item, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_vm._v(_vm._s(item.title))]), _c('td', {
      staticClass: "s-text-right"
    }, [_vm._v(_vm._s(item.quantity))]), _c('td', {
      staticClass: "s-text-right"
    }, [_vm._v(_vm._s(item.total_payment))])]);
  }), 0)])]), _c('DetailSection', {
    attrs: {
      "icon": "currency",
      "title": "付款資訊"
    }
  }, [_c('table', {
    staticClass: "s-text-sm s-w-full"
  }, [_c('thead', [_c('tr', {
    staticClass: "s-font-semibold"
  }, [_c('th', [_vm._v("付款方式")]), _c('th', {
    staticClass: "s-text-right"
  }, [_vm._v("付款金額")])])]), _c('tbody', _vm._l(_vm.payments, function (payment, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_vm._v(_vm._s(payment.type))]), _c('td', {
      staticClass: "s-text-right"
    }, [_vm._v("NT$ " + _vm._s(payment.amount))])]);
  }), 0)])])], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }